import script from "./DocumentsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentsTab.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentsTab.vue?vue&type=style&index=0&id=74c0ad58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74c0ad58"]])

export default __exports__